import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import RequireAdmin from './components/RequireAdmin';
import Home from './pages/Home';
import Login from './pages/Login';
import Users from './pages/admin/Users';
import Audit from './pages/admin/Audit';
import JobsList from './pages/jobs/JobsList';
import JobDetail from './pages/jobs/JobDetail';
import NewJob from './pages/jobs/NewJob';
import CandidatesList from './pages/candidates/CandidatesList';
import PersonDetail from './pages/candidates/PersonDetail';
import ApplicationDetail from './pages/applications/ApplicationDetail';
import ProposeApplication from './pages/applications/ProposeApplication';

export default function App() {
  return (
    <>
      <UnauthenticatedTemplate>
        <Routes><Route path="*" element={<Login />} /></Routes>
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/jobs" element={<JobsList />} />
            <Route path="/jobs/new" element={<NewJob />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/jobs/:jobId/propose" element={<ProposeApplication />} />
            <Route path="/candidates" element={<CandidatesList />} />
            <Route path="/candidates/:id" element={<PersonDetail />} />
            <Route path="/applications/:id" element={<ApplicationDetail />} />
            <Route path="/admin/users" element={<RequireAdmin><Users /></RequireAdmin>} />
            <Route path="/admin/audit" element={<RequireAdmin><Audit /></RequireAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthenticatedTemplate>
    </>
  );
}
